import { useFormContext } from "react-hook-form";
import type { Person } from "@/services/api";
import type { DeleteConnectionFormValues } from "../../model/schema";
import { Record } from "../Record";

export const Content = () => {
  const { watch } = useFormContext<DeleteConnectionFormValues>();

  return (
    <>
      {watch("connections")?.map((item, index) => (
        <Record
          index={index}
          connection={item.connection as Person["personConnections"][number]}
          key={item.connection.id}
        />
      ))}
    </>
  );
};
